var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle119(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "331.26798290007264 214.59896656986933 16.264682240100285 16.361033430130703",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M343.53,222.68c.08,2.42-1.65,4.28-3.98,4.28-2.35,0-4.21-1.78-4.28-4.08-.07-2.36,1.69-4.23,4.02-4.28,2.33-.05,4.16,1.72,4.24,4.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle119);
export default __webpack_public_path__ + "static/media/twinkle-1-19.ea50a521fa51cea2adf7da1f41167416.svg";
export { ForwardRef as ReactComponent };